import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function Login() {
  const { user, login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user.email) return <Navigate to="/crm" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email.trim(), password);
    setBusy(false);
    if (ok) nav("/crm", { replace: true });
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-6 relative overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse 90% 75% at 50% 40%, #102558 0%, #0B1A45 35%, #07112F 65%, #04091E 90%, #02050F 100%)",
      }}
      data-testid="login-page"
    >
      <div
        className="absolute -z-10 inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(60% 55% at 50% 40%, rgba(70,120,230,0.30) 0%, transparent 70%)",
          filter: "blur(60px)",
        }}
      />

      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-10">
          <div className="text-amber-300/90 tracking-[0.35em] text-xs uppercase">
            Prospera Financial
          </div>
          <h1 className="text-white text-2xl font-light mt-2">Advisor Console</h1>
        </div>

        <form
          onSubmit={submit}
          className="rounded-3xl border border-white/10 backdrop-blur-xl p-8 shadow-2xl"
          style={{
            background:
              "linear-gradient(180deg, rgba(20,32,80,0.55) 0%, rgba(10,20,60,0.35) 100%)",
          }}
        >
          <label className="block mb-5">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 block">
              Email
            </span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="info@prosperafinancial.ca"
              data-testid="login-email"
              className="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-amber-300/40 focus:bg-black/40 transition"
            />
          </label>
          <label className="block mb-2">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 block">
              Password
            </span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-amber-300/40 focus:bg-black/40 transition"
            />
          </label>
          {error && (
            <div
              className="mt-4 text-sm text-red-300/90 bg-red-500/10 border border-red-500/20 rounded-xl px-4 py-2.5"
              data-testid="login-error"
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full mt-6 py-3 rounded-xl font-medium text-black relative overflow-hidden group disabled:opacity-60"
            style={{
              background:
                "linear-gradient(180deg, #f4d47b 0%, #d4a53a 55%, #b78a2f 100%)",
              boxShadow:
                "0 10px 28px -12px rgba(212,165,58,0.55), inset 0 1px 0 rgba(255,255,255,0.5), inset 0 -1px 0 rgba(0,0,0,0.15)",
            }}
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <div className="mt-6 text-center text-xs text-white/40">
            Private access · Prospera Financial Inc.
          </div>
        </form>
      </div>
    </div>
  );
}
